<div class="w-100">
  <mat-card>
    <mat-card-content>
      <div class="logo">
        <img  [src]="imageLogo" style="max-width: 130px;" />
      </div>
      <ng-content select="[add-contents]"></ng-content>
    </mat-card-content>
    <mat-card-content class="pt-1" >
      <mat-card-content>
        <button mat-raised-button (click)="goToDashboard()" class="w-100" style="display: flex;justify-content: space-between;">
          <span>Dashboard</span>  <mat-icon matListItemIcon>dashboard</mat-icon> 
        </button>
      </mat-card-content>
      <mat-accordion>
        <mat-expansion-panel [expanded]="step() === 0" (opened)="setStep(0)" >
          <mat-expansion-panel-header class="w-100" >
            <mat-panel-title>
              {{appName}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div style="display: flex; flex-direction: column; gap: 5px;">
            <button mat-raised-button (click)="goToCustomersList()" *ngIf="hasPermission('CUSTOMERS.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Customers</span><mat-icon >person</mat-icon> 
            </button>
            <button mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('VEHICLES.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Vehicles</span><mat-icon matListItemIcon>directions_car</mat-icon> 
            </button>
            <button mat-raised-button (click)="goToDevicesList()"  *ngIf="hasPermission('TRACKERS.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Trackers</span>  <mat-icon matListItemIcon>gps_fixed</mat-icon> 
            </button>
            <button  disabled="true" mat-raised-button  class="w-100" style="display: flex;justify-content: space-between;">
              <span>Support Warranty Device</span>  <mat-icon matListItemIcon>support_agent</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToDevicesList()" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Support Warranty SIM</span>  <mat-icon matListItemIcon>support_agent</mat-icon> 
            </button>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="step() === 1" (opened)="setStep(1)">
          <mat-expansion-panel-header class="w-100" >
            <mat-panel-title>
              OTHER
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div style="display: flex; flex-direction: column; gap: 5px;">
            <button mat-raised-button (click)="goToGpsDataList()"  *ngIf="hasPermission('GPS.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>GPS</span>  <mat-icon matListItemIcon>widgets</mat-icon> 
            </button>
            <button mat-raised-button (click)="goToAlarmsList()" *ngIf="hasPermission('ALARM.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Alarm</span>  <mat-icon matListItemIcon>alarm</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToCustomersList()" *ngIf="hasPermission('CANBUS.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>CanBus</span><mat-icon >person</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('DRIVING-BEHAVIOUR.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Driving Behaviour</span><mat-icon matListItemIcon>directions_car</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToDevicesList()" *ngIf="hasPermission('HAND-SHAKE.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Handshake</span>  <mat-icon matListItemIcon>gps_fixed</mat-icon> 
            </button>
            <button disabled="true"  mat-raised-button (click)="goToAlarmsList()" *ngIf="hasPermission('VEHICLE-TYPE.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Vehicle Type</span>  <mat-icon matListItemIcon>alarm</mat-icon> 
            </button>

          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="step() === 2" (opened)="setStep(2)">
          <mat-expansion-panel-header class="w-100" >
            <mat-panel-title>
              CMS
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div style="display: flex; flex-direction: column; gap: 5px;">
            <button disabled="true" mat-raised-button (click)="goToDevicesList()" *ngIf="hasPermission('LANGUAGE.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Language</span>  <mat-icon matListItemIcon>translate</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToCustomersList()" *ngIf="hasPermission('MOBILE-LANGUAGE-RESOURCE.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Mobile Language Resource</span><mat-icon >translate</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('SERVICE-TYPE.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Service Type</span><mat-icon matListItemIcon>miscellaneous_services</mat-icon> 
            </button>
            <button mat-raised-button (click)="goToTelCompanyList()" *ngIf="hasPermission('TELEPHONE-COMPANY.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Telephone Company</span>  <mat-icon matListItemIcon>ring_volume</mat-icon> 
            </button>
            <button mat-raised-button (click)="goToAppInfoList()" *ngIf="hasPermission('APP-INFO.MENU')"class="w-100" style="display: flex;justify-content: space-between;">
              <span>App Info.</span>  <mat-icon matListItemIcon>alarm</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToDevicesList()" *ngIf="hasPermission('APP-SETTINGS.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>App Settings</span>  <mat-icon matListItemIcon>gps_fixed</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToDevicesList()" *ngIf="hasPermission('ATTRIBUTES.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Attributes</span>  <mat-icon matListItemIcon>gps_fixed</mat-icon> 
            </button>
          </div>
          

          
          
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="step() === 3" (opened)="setStep(3)">
          <mat-expansion-panel-header class="w-100" >
            <mat-panel-title>
              USERS
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div style="display: flex; flex-direction: column; gap: 5px;">
            <button mat-raised-button (click)="goToUsersList()" *ngIf="hasPermission('USERS.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Users</span>  <mat-icon matListItemIcon>people_alt</mat-icon> 
            </button>
            <button mat-raised-button (click)="goToRolesList()" *ngIf="hasPermission('ROLES.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Roles</span><mat-icon >manage_accounts</mat-icon> 
            </button>
            <button mat-raised-button (click)="goToPermissionsList()" *ngIf="hasPermission('PERMISSIONS.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Permissions</span><mat-icon matListItemIcon>verified</mat-icon> 
            </button>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="step() === 4" (opened)="setStep(4)">
          <mat-expansion-panel-header class="w-100" >
            <mat-panel-title>
              BILLING
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div style="display: flex; flex-direction: column; gap: 5px;">
            <button mat-raised-button (click)="goToRenewList()" *ngIf="hasPermission('RENEW-MANAGEMENT.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Renew Management</span>  <mat-icon matListItemIcon>people_alt</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToCustomersList()" *ngIf="hasPermission('ORDER.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Order</span><mat-icon >manage_accounts</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('RENEWAL-PRICE.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Renewal Price</span><mat-icon matListItemIcon>verified</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('PRODUCT.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Product</span><mat-icon matListItemIcon>verified</mat-icon> 
            </button>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="step() === 5" (opened)="setStep(5)">
          <mat-expansion-panel-header class="w-100" >
            <mat-panel-title>
              UTILS
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div style="display: flex; flex-direction: column; gap: 5px;">
            <button disabled="true"  mat-raised-button (click)="goToUsersList()" *ngIf="hasPermission('DETACT-SIM.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Detach SIM</span>  <mat-icon matListItemIcon>no_sim</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToCustomersList()" *ngIf="hasPermission('ATTACH-SIM.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Attach SIM</span><mat-icon >sim_card</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('TERMINATE-SIM.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Terminate SIM</span><mat-icon matListItemIcon>sim_card_alert</mat-icon> 
            </button>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="step() === 6" (opened)="setStep(6)">
          <mat-expansion-panel-header class="w-100" >
            <mat-panel-title>
              SETTINGS
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div style="display: flex; flex-direction: column; gap: 5px;">
            <button mat-raised-button (click)="goToAssignDevices('agent')" *ngIf="hasPermission('ASSIGN-DEVICE.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Assign Device</span>  <mat-icon matListItemIcon>assignment</mat-icon> 
            </button>
            <button disabled="true"  mat-raised-button (click)="goToAssignDevices('retailer')" *ngIf="hasPermission('ASSIGN-RETAILER.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Assign Retailer</span><mat-icon matListItemIcon>assignment</mat-icon> 
            </button>
            <button mat-raised-button (click)="goToAssignDevices('distributor')" *ngIf="hasPermission('ASSIGN-DISTRIBUTOR.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Assign Distributor</span><mat-icon matListItemIcon>assignment</mat-icon> 
            </button>
            <button mat-raised-button (click)="goToAssignDevices('agent_retailer')" *ngIf="hasPermission('ASSIGN-ANGENT-RETAILER.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Assign Agent Retailer</span><mat-icon matListItemIcon>assignment</mat-icon> 
            </button>
            <mat-divider></mat-divider>
            <button disabled="true" mat-raised-button (click)="goToAssignDevices('licence')" *ngIf="hasPermission('ASSIGN-LICENCE.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Assign Licence</span><mat-icon >assignment</mat-icon> 
            </button>
            <mat-divider></mat-divider>
            <button disabled="true"  mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('AUDIT-LOG.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Audit Log</span><mat-icon matListItemIcon>verified</mat-icon> 
            </button>
            <button disabled="true"  mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('AUDIT-LOG-LICENCE.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Audit Log Licence</span><mat-icon matListItemIcon>verified</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('GPS-DELETED-DATA.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>GPS Deleted data</span><mat-icon matListItemIcon>delete_outline</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('USER-FEEDBACK.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>User Feedback</span><mat-icon matListItemIcon>comment</mat-icon> 
            </button>
            
            <button disabled="true" mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('EMAIL-SETTINGS.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Email settings</span><mat-icon matListItemIcon>contact_mail</mat-icon> 
            </button>
            <button mat-raised-button (click)="goToEmailTemplateList()" *ngIf="hasPermission('EMAIL-TEMPLATE.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Email Template</span><mat-icon matListItemIcon>drafts</mat-icon> 
            </button>
            <button mat-raised-button (click)="goToSimDetailsList()" *ngIf="hasPermission('SIM.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>SIM</span><mat-icon matListItemIcon>verified</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('UTILITY.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Utility</span><mat-icon matListItemIcon>verified</mat-icon> 
            </button>
            <button disabled="true" mat-raised-button (click)="goToVehiclesList()" *ngIf="hasPermission('TRANSFER-DEVICE.MENU')" class="w-100" style="display: flex;justify-content: space-between;">
              <span>Transfer Device </span><mat-icon matListItemIcon>verified</mat-icon> 
            </button>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
  </mat-card>
  
</div>

